import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccountSettingsUpdateInput } from '@wb/core/schema/mutation-definitions/accounts.graphql';
import { AccountService } from '@wb/core/services/account.service';
import { AnalyticService } from '@wb/core/services/analytic.service';
import { InventoryService } from '@wb/core/services/inventory.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-delist-dialog',
  templateUrl: './delist-dialog.component.html',
  styleUrls: ['./delist-dialog.component.sass'],
})
export class DelistDialogComponent implements OnDestroy {
  @Output() save: EventEmitter<void> = new EventEmitter();

  formGroup: FormGroup = new FormGroup({
    delist: new FormControl(null),
  });

  delisted: string | null | undefined;

  isLoadingData = true;

  private destroyed$: Subject<void> = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { delist: boolean; accountUid: string; account: AccountService; inventory: InventoryService },
    public dialogRef: MatDialogRef<DelistDialogComponent>,
    private accountService: AccountService,
    private analytics: AnalyticService,
  ) {
    this.formGroup.patchValue({ delist: this.data.delist });
    this.isLoadingData = false;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  async onSubmit() {
    const delist: AccountSettingsUpdateInput[] = [
      {
        key: 'delist',
        value: this.formGroup.value.delist,
      },
    ];

    this.accountService.updateAccountSettings(this.data.accountUid as string, delist).then((response) => {
      if (!(response instanceof HttpErrorResponse)) {
        this.data.account.refetchAccount();
        this.data.inventory.refetchInventory();
        this.dialogRef.close(true);
      }
    });
    this.analytics.track({ object: 'Inventory', action: 'Click', properties: { type: 'submit_delist_selection' } });
  }
}
